import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Tabs } from '@resurs/midas-react'
import { Conditional } from '@resurs/react-utils'
import {
  getIdentificationStatus,
  pageHalt,
} from '../../../../store/actions/pay-apply-actions'
import { validateDate } from '../../../../util/governmentIdUtils'
import PageWrapper from '../../../../internal/PageWrapper'
import { getText } from '../../../../internal/TextLabels'
import FlowModalUI from '../shared/FlowModalUI'
import PaymentIdentificationPageAnalogUI from './UI/PaymentIdentificationPageAnalogUI'
import PaymentIdentificationPageDigitalUI from './UI/PaymentIdentificationPageDigitalUI'
import { getBankIDLogoFromCountryCode } from '../shared/utils'
import { successAnimation } from '../../../../assets/animations'
import { SigningTypes } from '../../../../util/paymentModel'

class PaymentIdentificationPage extends Component {
  constructor(props) {
    super(props)
    this.bankIdLogo = getBankIDLogoFromCountryCode(
      this.props.data.addressInfo.countryCode,
    )
    this.state = {
      selectedSigningMethod: SigningTypes.ELECTRONIC,
    }
  }

  handleCloseModal() {
    this.setState({ signModal: false }, this.props.onPageHalt())
  }

  onManualIdentification(info) {
    const data = info
    data.manualIdentification = true
    this.props.onNext(data)
  }

  getBankIdTab(result) {
    return validateDate(
      this.props.data.current.governmentId,
      this.props.data.addressInfo.countryCode,
    )
      ? [
          {
            value: getText('payApply.identify.bankID'),

            content: (
              <PaymentIdentificationPageDigitalUI
                data={this.props.data}
                result={result}
                bankIdLogo={this.bankIdLogo}
                onNext={() => {
                  this.setState({ signModal: true })
                  this.props.onNext(this.state)
                }}
                newPageLoading={this.props.data.wizard.newPageLoading}
              />
            ),
          },
        ]
      : []
  }

  render() {
    const result = this.props.data.payment.paymentResult
    return (
      <PageWrapper
        type="success"
        title={getText('payApply.identify.pageTitle')}
      >
        <div
          style={{
            opacity: this.props.data.wizard.onPageLoading && '0.3',
            display: 'relative',
            padding: '2rem',
          }}
        >
          <div style={{ display: 'flex', paddingBottom: '2rem' }}>
            <img
              style={{ marginRight: '2rem' }}
              src={successAnimation}
              alt="Success animation"
            />
            <h6 style={{ margin: '1.2rem 0 0 0' }}>
              {getText('payApply.identify.titleSuccess')}
            </h6>
          </div>
          <Tabs
            fullWidth
            defaultTab={0}
            values={this.getBankIdTab(result).concat([
              {
                value: getText('payApply.identify.paper'),
                content: (
                  <PaymentIdentificationPageAnalogUI
                    data={this.props.data}
                    result={result}
                    onNext={info => this.onManualIdentification(info)}
                    newPageLoading={this.props.data.wizard.newPageLoading}
                  />
                ),
              },
            ])}
          />
          <Conditional when={!!this.state.signModal}>
            <FlowModalUI
              show
              data={this.props.data}
              onComplete={() => {
                this.props.updateIdentificationStatus()
              }}
              onClose={() => {
                this.handleCloseModal()
              }}
            />
          </Conditional>
        </div>
      </PageWrapper>
    )
  }
}

PaymentIdentificationPage.propTypes = {
  data: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  updateIdentificationStatus: PropTypes.func.isRequired,
  onPageHalt: PropTypes.func.isRequired,
}

export default connect(null, dispatch => ({
  updateIdentificationStatus: () => {
    return dispatch(getIdentificationStatus)
  },
  onPageHalt: () => {
    dispatch(pageHalt())
  },
}))(PaymentIdentificationPage)
